export default function versionComparable(version: string) {
  // version is something like 15.33.2
  // return is a number such that versionComparable(x) < versionComparable(y)
  // when x is a lower version than y
  // and equal if they are the same
  return version.split('.').reduce((total, currentValue, i) => {
    return total + +currentValue * 10 ** (8 - 4 * i);
  }, 0);
}
